<template>
    <div class="article_stats_chart fs14">
        <p class="title">{{ title }}</p>
        <div v-if="!slotmag" class="mag">
            <p v-html="contentStr"></p>
        </div>
        <slot v-else></slot>
        <div class="report_stats_chart" :id="chartBox"></div>
    </div>
</template>

<script>

let echarts = require('echarts');
import _ from "loadsh";

export default {
    name: 'ArticleStatsChart',
    props: {
        renderData: Array,
        entity: String,
        slotmag: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: "高管报道"
        },
        chartBox: {
            type: String,
            default: "reportCountChart"
        }
    },
    data() {
        return {
            names: [],
            positive: [],
            negative: [],
            neutral: [],
            contentStr: `今日，${this.entity}暂无高管相关报道。`
        }
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        init: function () {
            let self = this;

            let list = _.orderBy(this.renderData, ["negative", "count"], ["asc", "asc"]);

            list.forEach((item) => {
                this.names.push(item.name)
                this.positive.push(item.positive)
                this.negative.push(item.negative)
                this.neutral.push(item.neutral)

            })

            if(list.length){
                // let negMax = _.maxBy(list,"negative");
                // let maxInfo = _.maxBy(list,"count");
                // let total = _.sumBy(list, "count")
                let maxInfos = [];
                let max = 0;
                list.forEach(e => {
                    if (e.count > max) {
                        maxInfos = [e];
                        max = e.count;
                    } else if (e.count === max) {
                        maxInfos.push(e);
                    }
                })
                if (maxInfos.length) {
                    let maxInfoNameStr = _.chain(maxInfos).reverse().map(e => e.name).join('、').value();
                    this.contentStr = `今日，${this.entity}高管${maxInfoNameStr}报道量相对较多，达${max}篇。`
                }
            }



            let chart = echarts.init(document.getElementById(self.chartBox));
            let option = {
                colorl: ['#FB7361', '#FEBB32', '#65DE8E'],
                center: ["50%", "70%"],
                grid: {
                    top: '10%',
                    left: '0%',
                    right: '7%',
                    bottom: '3%',
                    containLabel: true
                },
                legend: {
                    top: 0,
                    left: 0,
                    itemWidth: 3,
                    itemHeight: 3,
                    selectedMode: false,
                    itemStyle: {
                        borderColor: '#c9c9ca',
                        borderWidth: 0.5
                    },
                    orient: 'horizontal',
                    textStyle: {
                        fontSize: 10,
                        // color: '#96A4F4',
                        // padding: [3, 0, 0, 0]
                    },
                    data: [{
                        name: '敏感报道',
                        textStyle: {
                            color: '#FB7361'
                        }
                    }, {
                        name: '中性报道',
                        textStyle: {
                            color: '#FEBB32'
                        },
                    }, {
                        name: '正面报道',
                        textStyle: {
                            color: '#65DE8E'
                        },
                    }
                    ]
                },
                yAxis: [{
                    type: 'category',
                    data: this.names,
                    axisLine: { //  改变x轴颜色
                        lineStyle: {
                            color: "rgba(256,256,256,0)",
                        }
                    },
                    axisLabel: { //  改变x轴字体颜色和大小
                        textStyle: {
                            color: "#6E7079",
                            fontSize: 10
                        },
                        interval: 0,
                        // rotate:40 ,
                        grid: {
                            left: '10%',
                            bottom: '35%'
                        },
                    },
                }, {
                    type: 'category',
                    name: '报道量(篇）',
                    axisLine: { //  改变x轴颜色
                        lineStyle: {
                            color: "rgba(256,256,256,0)",
                        }
                    },
                    nameTextStyle: {
                        color: '#6E7079',
                        fontWeight: 'bold',
                        fontSize: 10,
                        align: 'right',
                    },
                    axisLabel: { //  改变x轴字体颜色和大小
                        textStyle: {
                            color: "#6E7079",
                            fontSize: 10
                        },
                        interval: 0,
                        // rotate:40 ,
                        grid: {
                            left: '10%',
                            bottom: '35%'
                        },
                    },
                }],
                xAxis: {
                    type: 'value',

                    axisLine: { //  改变y轴颜色
                        show: false,
                        lineStyle: {
                            color: "#6E7079",
                        }
                    },
                    axisLabel: { //  改变y轴字体颜色和大小
                        textStyle: {
                            color: "#6E7079",
                            fontSize: 10,
                        },
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#C9C9CA',
                            width: 1,
                            type: 'dotted'
                        }
                    }
                },
                series: [
                    {
                        name: '敏感报道',
                        type: 'bar',
                        stack: '总量',
                        barWidth: 16,
                        label: {
                            show: false,
                            position: 'right'
                        },
                        itemStyle: {
                            normal: {
                                color: '#FB7361',
                                borderColor: '#FB7361',
                                borderWidth: 0.5,
                                // color: '#376CCF',  //圈圈的颜色
                                // barBorderRadius: [20, 0, 0, 20],
                            }
                        },
                        data: this.negative
                    },
                    {
                        name: '中性报道',
                        type: 'bar',
                        stack: '总量',
                        barWidth: 16,
                        label: {
                            show: false,
                            position: 'right'
                        },
                        itemStyle: {
                            normal: {
                                color: '#FEBB32',
                                borderColor: '#FEBB32',
                                borderWidth: 0.5,
                                // color: '#87A7E2',  //圈圈的颜色
                            }
                        },
                        data: this.neutral
                    },
                    {
                        name: '正面报道',
                        type: 'bar',
                        stack: '总量',
                        label: {
                            show: true,
                            position: 'right',
                            color: "#6E7079",
                            fontWeight: '500',
                            fontSize: 12,
                            formatter: function (params) {
                                let total = params.value + self.negative[params.dataIndex] + self.neutral[params.dataIndex];

                                return  `${total}`
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#65DE8E',
                                borderColor: '#65DE8E',
                                borderWidth: 0.5,
                                // color: '#C3D2F0',  //圈圈的颜色
                                // barBorderRadius: [0, 20, 20, 0],
                            },
                        },
                        data: this.positive
                    }
                ]
            };

            chart.setOption(option);
        }
    }
}
</script>

<style lang="scss" scoped>
.article_stats_chart {
    box-sizing: border-box;
    background-color: #FFFFFF;
    //padding: 16px;

    .title {
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        text-indent: 20px;
        background-size: 18px 18px;
        margin-bottom: 12px;
        background: url("../../assets/img/icon/media.png") no-repeat left;

    }

    .mag {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
    }

    .report_stats_chart {
        margin-top: 28px;
        width: 100%;
        height: 300px;
        padding: 0px 15px;

    }

}
</style>